import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution } from "@/lib/attribution";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    // Capture UTM/referrer on every navigation; first-touch wins inside the helper.
    try { captureAttribution(); } catch { /* ignore */ }
  }, [pathname]);
  return null;
};

export default ScrollToTop;
